import { MESSAGES, UserRole } from '../../utils/constants'
import { MIDDLELAYER_API } from '../../utils/constants/endpoints'
import { emailRegex } from '../../utils/regex'
import { AssociationResponse, IAssociation } from '../../utils/types/dashboard'
import { Axios } from '../axios'

const isProvider = (userRole: UserRole) => userRole === UserRole.Provider

const errorIdentity = (userRole: UserRole) =>
    isProvider(userRole) ? UserRole.Esthetician : UserRole.Provider

export const addAssociationService = async (
    userRole: UserRole,
    data: string
) => {
    const payload = {
        requestId: emailRegex.test(data) ? data : data.toUpperCase(),
    }
    try {
        const response: any = await Axios.middleLayerInstance.post(
            MIDDLELAYER_API.ADD_ASSOCIATION,
            payload
        )
        if (!response.success) {
            throw new Error(response.message)
        }
    } catch (e: any) {
        if (e.message) throw new Error(e.message)
        else
            throw new Error(
                MESSAGES.error.failedTo('add', errorIdentity(userRole))
            )
    }
}

export const getAssociationsService = async (userRole: UserRole) => {
    try {
        const response =
            await Axios.middleLayerInstance.get<AssociationResponse>(
                MIDDLELAYER_API.GET_PROVIDER_ESTI
            )

        return (
            response.data ?? {
                requests: [],
                confirmed: [],
            }
        )
    } catch (e) {
        throw new Error(
            MESSAGES.error.failedTo('fetch', errorIdentity(userRole))
        )
    }
}

export const getEstiProviders = async () => {
    try {
        const response = await Axios.middleLayerInstance.get<IAssociation[]>(
            MIDDLELAYER_API.GET_PROVIDER_LIST
        )
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const markAsReadService = async () => {
    try {
        await Axios.middleLayerInstance.get(MIDDLELAYER_API.MARK_AS_READ)
    } catch (e) {
        throw new Error(MESSAGES.error.failedTo('Mark as read'))
    }
}

export const manageAssociationRequestService = async (
    email: string,
    isApproved: boolean
) => {
    const payload = {
        changeRequestStatus: {
            email: email,
            status: isApproved,
        },
    }

    try {
        await Axios.middleLayerInstance.post(
            MIDDLELAYER_API.MANAGE_ASSOCIATION_REQUEST,
            payload
        )
    } catch (e) {
        if (isApproved) throw new Error(MESSAGES.error.failedTo('add', email))
        else
            throw new Error(
                MESSAGES.error.failedTo('cancel request from', email)
            )
    }
}

export const removeAssociationService = async (
    userRole: UserRole,
    appUserKey: string
) => {
    const payload = {
        changeRequestStatus: {
            email: appUserKey,
        },
    }
    try {
        await Axios.middleLayerInstance.delete(MIDDLELAYER_API.DELETE_REQUEST, {
            data: payload,
        })
    } catch (e) {
        throw new Error(
            MESSAGES.error.failedTo('remove', errorIdentity(userRole))
        )
    }
}
